import {Component, Inject, OnInit} from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { LoadingService } from "../gather-services/loading.service";
import { ApiWithLoadingService } from "../gather-services/api-with-loading.service";
import { GatherApiService } from "../gather-services/gather-api.service";
import { SharedDataService } from "../gather-services/shared-data.service";
import { Availability, Gather, JobPosting } from "../gather-typings";
import { Subscription } from "rxjs";
import { Country } from "../enums";
import { EnvironmentToken } from "../../../util";
import { Environment } from "../../../typings";
import { GatherStateService } from "../gather-services/gather-state.service";

const UPDATE_PROFILE_PATH = '/myaquent/profile';
const TRACK_STATUS_PATH = '/myaquent?PROC=AWUIDrawJobCenterMain';
const JOB_CENTER_PATH = '/myaquent?PROC=AWUIDrawAdvancedJobSearch';
const REFER_FRIEND_URL = 'http://www.aquent.com/rewards';
const JAPAN_JOB_CENTER_URL = 'https://aquent.co.jp/jobs';
const OUTSIDE_REVIEW_SECTION = '#profile-reviews-section';
const JOB_PREFERENCES_PATH = '/myaquent/jobPreferences';
@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent implements OnInit {

  trackingId: string = null;
  availability: Availability = {};
  gather: Gather = null;
  jobPosting: JobPosting = null;
  alreadySubmitted: boolean = false;
  confirmationLabel: string = null;
  countryId: number;
  isJapanOrFrance: boolean = false;
  fromRoute: string = null;
  aquentWebsite: string;
  matHost: string;
  isJapanOrder: boolean;

  private subscriptions = new Subscription();

  constructor(private route: ActivatedRoute,
              private loadingService: LoadingService,
              private api: ApiWithLoadingService,
              private gatherApiService: GatherApiService,
              private sharedDataService: SharedDataService,
              private gatherStateService: GatherStateService,
              @Inject(EnvironmentToken) private environment: Environment) { }

  ngOnInit(): void {
    this.aquentWebsite = this.environment.aquentWebsite;
    this.matHost = this.environment.matHost;

    this.alreadySubmitted =
      this.route.snapshot.queryParamMap.has('alreadySubmitted') && this.route.snapshot.queryParamMap.get('alreadySubmitted') === 'true';
    this.fromRoute = this.route.snapshot.queryParamMap.get('fromRoute');

    this.subscriptions.add(
      this.sharedDataService.gather.subscribe(gather => {
        this.gather = gather;
      })
    );

    this.subscriptions.add(
      this.sharedDataService.jobPosting.subscribe(jobPosting => {
        this.jobPosting = jobPosting;
        this.countryId = this.jobPosting.countryId;
        this.isJapanOrFrance = this.jobPosting.countryId === Country.France || this.jobPosting.countryId === Country.Japan;
        this.isJapanOrder = jobPosting.countryId === Country.Japan; 
      })
    );

    this.subscriptions.add(
      this.sharedDataService.talentAvailability.subscribe(availability => {
        this.availability = availability;

        if (this.alreadySubmitted) {
          this.confirmationLabel = 'gather.second-time.thank-you-text';
        } else if (this.fromRoute  === 'not-interested') {
          this.confirmationLabel = 'gather.not-interested.thank-you-text';
        } else {
          this.confirmationLabel = 'gather.thank-you-text';
        }
      })
    );

    this.gatherStateService.setTitle(this.fromRoute  === 'interested'?'gather.interested.confirm.title':'gather.not-interested.confirm.title');
  }

  goToUrl(buttonType: string) {
    switch (buttonType) {
      case 'job':
        if (this.countryId === Country.Japan) {
          window.location.href = JAPAN_JOB_CENTER_URL;
        } else {
          window.location.href = this.matHost + JOB_CENTER_PATH;
        }
        break;
      case 'status':
        window.location.href = this.matHost + TRACK_STATUS_PATH;
        break;
      case 'profile':
        window.location.href = this.matHost + UPDATE_PROFILE_PATH;
        break;
      case 'reviews':
        window.location.href = this.matHost + UPDATE_PROFILE_PATH + OUTSIDE_REVIEW_SECTION;
        break;
      case 'refer':
        window.location.href = REFER_FRIEND_URL;
        break;
      case 'jobPreferences':
        window.location.href = this.matHost + JOB_PREFERENCES_PATH;
        break;
    }
  }



}
